/**
 * Manufacturing-module SharePoint site configuration.
 *
 * The Production Grid (Excel-import version) lives on its OWN site with its
 * own lists, fully separate from the i-SYNERGYTest site that hosts the SPFx
 * scanning system's lists. This keeps the two data sets isolated — the Excel
 * import can never touch the live scanning lists — and makes side-by-side
 * comparison of the two versions possible (per Mikko, 2026-07-11).
 *
 * The new site's lists are provisioned by GridProvisioningService (one-click
 * "Set up lists" in the grid) — safe because they are brand-new lists this
 * app alone owns; the historical schema-pollution ban applies to the LEGACY
 * site's already-populated lists, which this app no longer writes to.
 */

/** The Production Grid's own site (Excel-import version). */
export const MFG_SITE_URL =
  (import.meta.env?.VITE_SHAREPOINT_MFG_SITE_URL as string | undefined) ??
  "https://intalgarmentsopc.sharepoint.com/sites/Manufacturing";

/** The old SPFx/scanning site — read-only fallback for one-time migration
 * (style settings) and comparison. Never written to by this app anymore. */
export const LEGACY_MFG_SITE_URL =
  "https://intalgarmentsopc.sharepoint.com/sites/i-SYNERGYTest";

/** Server-relative path of the site's default Documents library. */
export function mfgDocumentsPath(): string {
  return `${new URL(MFG_SITE_URL).pathname}/Shared Documents`;
}
